

























import Vue from 'vue'
import { EventService } from '../../base/services/EventService'

export default Vue.extend({
  data() {
    return {
      isPristine: true
    }
  },
  computed: {
    eventService() {
      return EventService
    }
  },
  methods: {
    onPristineStateChange(isPristine: boolean) {
      this.isPristine = isPristine
    }
  },
  created() {
    EventService.$on('wb-pristine-state-change', this.onPristineStateChange)
  },
  destroyed() {
    EventService.$off('wb-pristine-state-change', this.onPristineStateChange)
  }
})
